module.exports = __webpack_public_path__ + "MaterialIcons-Regular.012cf6a10129e2275d79.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/MaterialIcons-Regular/MaterialIcons-Regular.woff
// module id = 777
// module chunks = 1